export const  partnersData = [
    {
        id: 1,
        name: 'Tevel',
        description: 'Partnered with Africa Access Water (AfAW) on the Mphande Hills Development Project, working across three villages in Kafue District, Lusaka Province. Providing solar powered water facilities on communal land using the AfAW model and has four sites with three extra clean drinking water kiosks.',
        logo: '/img-optimized/partners/Tevel_Logo.png',
        url: 'https://tevelbtzedek.org/tevel_partners/africa-access-water/'
    },

    {
        id: 2,
        name: 'Segal Family Foundation',
        description: 'Provides institutional support through a combination of unrestricted funding and capacity-building initiatives. This includes offering platforms for organizational growth and leadership development, such as supporting the CEO through the African Visionary Fellowship.',
        logo: '/img-optimized/partners/Segal_Logo.png',
        url: 'https://www.segalfamilyfoundation.org/partners/africa-access-water/'
    },

    {
        id: 3,
        name: 'Nelly Mutti Foundation',
        description: 'Partnered with AfAW in establishing the Makeni Solar-Powered Water Demonstration Site. This site showcases AfAW’s model to high-profile stakeholders, including Members of Parliament and government officials, with the aim of promoting replication, government uptake, and sustainable financing mechanisms.',
        logo: '/img-optimized/partners/nmf.png',
        url: 'https://www.parliament.gov.zm/node/12251'
    },
    
    {
        id: 4,
        name: 'Baba Group of Companies',
        description: 'A long-standing partner that has supported AfAW from its inception. Contributions include funding the first project in Shibuyunji, supporting office operations and administration, and ongoing investment in projects through borehole drilling and well construction. The group has also supported the Masopo Project in Choma.',
        logo: '/img-optimized/partners/Baba_Logo.png',
        url: 'http://www.babadrill.com/'
    },

    {
        id: 5,
        name: 'NGO WASH Forum',
        description: 'The largest network of local and international NGOs and CSOs working in water, sanitation, and hygiene in Zambia. It provides AfAW with capacity-building opportunities, sector visibility, and strategic engagement platforms.',
        logo: '/img-optimized/partners/NGO_WASH_Logo.png',
        url: 'https://ngowash.co.zm/'
    },

    {
        id: 6,
        name: 'Silent Donor',
        description: 'Africa Access Water is pleased to announce a new collaboration with Silent Donor, helping expand opportunities for supporters around the world to contribute to sustainable clean water solutions across rural Zambia.',
        logo: '/img-optimized/partners/SDlogodefault.png',
        url: 'https://www.silentdonor.com/donate-now-africa-access-water/'
    },

    {
        id: 7,
        name: 'Google',
        description: ' Has supported AfAW with approximately USD 10,000 in Google Ads grants and provides access to premium digital tools, including professional email services and other online platforms.',
        logo: '/img-optimized/partners/Google_Logo.png',
        url: 'https://www.google.com/'
    },

    {
        id: 8,
        name: 'Ministry of Water Development and Sanitation',
        description: 'As the primary government body responsible for water service provision, the Ministry works in alignment with AfAW’s efforts to complement national service delivery. AfAW has partnered with the Ministry on initiatives such as the Water Economy Dialogue, which promotes water for productive use and positions water as a key economic driver.',
        logo: '/img-optimized/partners/Ministry_of_Water_Logo.png',
        url: 'https://www.mwds.gov.zm/'
    },

    {
        id: 9,
        name: 'Centre for Environmental Justice (CEJ)',
        description: 'Partnered with AfAW on environmental aspects of project implementation, ensuring sustainability and compliance with environmental standards.',
        logo: '/img-optimized/partners/CEJ_Logo.png',
        url: 'https://cejzambia.org/'
    },

    {
        id: 10,
        name: 'MASHAV (Israel’s Agency for International Development Cooperation)',
        description: 'Provided support to the Shibuyunji project by expanding water infrastructure and fencing operational areas to enhance sustainability and security.',
        logo: '/img-optimized/partners/MASHAV_Logo.png',
        url: 'https://mashav.mfa.gov.il/'
    },

    {
        id: 11,
        name: 'Maurice Dillon',
        description: 'A long-term supporter of Africa Access Water (AfAW), who initially provided a catalytic contribution of USD 20,000. He has continued to support the organization’s work over time and regularly visits project sites, at least twice a year, to provide oversight, encouragement, and strategic engagement.',
        logo: '/img-optimized/partners/MauriceDillon_Logo.png',
        url: 'linkedin.com/in/maurice-dillon-869b642b9/'
    },


];